/**
 * @deprecated legacy file. This file is depricated and will be removed in the future.
 * Please migrate to useLabelTranslation instead.
 */

import * as React from 'react';
import I18nContext from 'src/contexts/i18n-context';


export default function useI18n() {
  return React.useContext(I18nContext);
}
